import { Link, NavLink } from 'react-router-dom';

export default function MarketingNav() {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/favicon-32.png" alt="Scrivera" className="w-7 h-7" />
          <span className="font-bold text-lg text-[#0A2540]">Scrivera</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-600">
          <NavLink to="/features" className={({ isActive }) => isActive ? 'text-[#0E7490]' : 'hover:text-[#0A2540]'}>Features</NavLink>
          <NavLink to="/pricing" className={({ isActive }) => isActive ? 'text-[#0E7490]' : 'hover:text-[#0A2540]'}>Pricing</NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? 'text-[#0E7490]' : 'hover:text-[#0A2540]'}>About</NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? 'text-[#0E7490]' : 'hover:text-[#0A2540]'}>Contact</NavLink>
        </nav>

        <Link
          to="/app/login"
          className="bg-[#0A2540] text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-[#0E7490] transition-colors"
        >
          Sign In
        </Link>
      </div>
    </header>
  );
}
